import PropTypes from 'prop-types';
import React from 'react';

const Overlay = ({ children, color, onClose }) => {
  const style = typeof color !== "undefined" ? { backgroundColor: color } : {};

  return <div className="overlay" style={style} onClick={onClose}>
    <div className="overlay-body">
      {children}
    </div>
  </div>
}

Overlay.propTypes = {
  children: PropTypes.element
};

export default Overlay;
